<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Journal Provider</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <InstitutionList ref="institutionList" />

      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="searchInstitution"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <v-select
            id="subscriptionType"
            v-model="paging.isASC"
            :items="[{type:'Ascending', value: true}, {type:'Descending', value: false}]"
            label="Order By"
            item-text="type"
            item-value="value"
            return-value="type"
            @change="getJournalsByPagin()"
          ></v-select>
        </div>
        <div class="col"></div>
        <div class="col pl-2">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Institution
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-text-field
                id="institutionName"
                label="Name *"
                v-model="selectedObj.Name"
                :rules="InstitutionalRules"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="institutionAddress"
                label="Address"
                v-model="selectedObj.Address"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
             <v-select
                v-model="selectedObj.country"
                id="Country"
                :items="countries"
                label="Country"
                item-text="CountryName"
                item-value="id"
                return-object
              ></v-select>
            </div>
            <div class="col">
              <v-text-field
                id="institutionPhone"
                label="Phone"
                v-model="selectedObj.phone"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="institutionWebsite"
                label="Website"
                v-model="selectedObj.website"
              ></v-text-field>
            </div>
            <div class="col">
            </div>
          </div>
          <v-divider></v-divider>
          <h4 class="pt-5">Contact Person</h4>
          <br>
          <div class="row">
            <div class="col">
              <v-text-field
                id="contactPersonName"
                label="Name"
                v-model="selectedObj.contactPersonName"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="contactPersonRole"
                label="Role"
                v-model="selectedObj.contactPersonRole"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="contactPersonEmail"
                label="Email"
                v-model="selectedObj.contactPersonEmail"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="contactPersonPhone"
                label="Phone"
                v-model="selectedObj.contactPersonPhone"
              ></v-text-field>
            </div>
          </div>
          <v-divider  class="pt-5"></v-divider>
          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="()=>{this.isEdit = false}" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
        <ConfirmationDialog ref="confirm" />
      </div>

      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" @click="sortByName" style="cursor: pointer;">Institute Name</th>
                  <th class="text-left" @click="sortAddress" style="cursor: pointer;">Address</th>
                  <th class="text-left" @click="sortCountry" style="cursor: pointer;">Country</th>
                  <th class="text-left" @click="sortWebsite" style="cursor: pointer;">Website</th>
                  <th style="width: 150px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Address }}</td>
                  <td>
                    {{ item.country != null ? item.country.CountryName : "" }}
                  </td>
                  <td>
                    {{ item.website != null ? item.website : "" }}
                  </td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                    <v-icon
                        class="mr-2"
                        @click="getJournalsList(item.Name)">
                        mdi-view-grid-outline
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import InstitutionList from "../components/InstitutionList.vue";

export default {
  name: "Institutions",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    InstitutionList,
  },
  computed: {},
  created() {
    this.getCountries();
    this.getJournalsByPagin();
  },
  methods: {
    getCountries() {
      this.countries = [];
      new Promise((resolve, reject) => {
        api
          .getAll("country")
          .then((response) => {
            console.log(response.data);
            this.countries = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getJournalsByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getJournalsByPagin();
    },
    getJournalsByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("institutions", this.paging)
          .then((response) => {
            that.overlay = false
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Address = "";
      this.selectedObj.website = "";
      this.selectedObj.phone = "";
      this.selectedObj.contactPersonName = "";
      this.selectedObj.contactPersonRole = "";
      this.selectedObj.contactPersonEmail = "";
      this.selectedObj.contactPersonPhone = "";
      this.valid = false;
      this.selectedObj.id = 0;
    },
    onSave() {
      let that = this;
      that.overlay = true
      this.$refs.form.validate();
      console.log(this.valid);
      if (!this.valid){
        that.overlay = false;
        return;
      }
      that.id = this.selectedObj.id;
      new Promise((resolve, reject) => {
        api
          .update("institutions", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              if (that.id == 0) {
                this.notify.message = "Record successfully created.";
              } else {
                this.notify.message = "Record successfully updated.";
              }
              this.getJournalsByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
              return response;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
            // that.overlay = false
          })
          .catch((error) => {
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Publisher name already exist");
              this.loading = false;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            }
            that.overlay = false
          });
      });

      this.isEdit = false;
      this.$refs.form.reset();
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("institutions", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getJournalsByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }

      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.$refs.form.reset();
    },
    getJournalsList(name) {
      new Promise((resolve, reject) => {
        api
          .getAll(`journal/${name}/journals`)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              this.$refs.institutionList.open(response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInstitutions() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("institutions")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
      sortByName() {
        this.nameSortAsc = !this.nameSortAsc;
      this.list = this.list.sort((a, b) => this.nameSortAsc ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name));
      },
      sortAddress() {
        this.addressSortAsc = !this.addressSortAsc;
        this.list = this.list.sort((a, b) => this.addressSortAsc ? a.Address.localeCompare(b.Address) : b.Address.localeCompare(a.Address));
     },
      sortCountry() {
        this.countrySortAsc = !this.countrySortAsc;
        this.list = this.list.sort((a, b) => {
          const countryA = a.country != null ? a.country.CountryName : "";
          const countryB = b.country != null ? b.country.CountryName : "";
          return this.countrySortAsc ? countryA.localeCompare(countryB) : countryB.localeCompare(countryA);
        });
      },
      sortWebsite() {
        this.websiteSortAsc = !this.websiteSortAsc;
        this.list = this.list.sort((a, b) => {
          const websiteA = a.website != null ? a.website : "";
          const websiteB = b.website != null ? b.website : "";
          return this.websiteSortAsc ? websiteA.localeCompare(websiteB) : websiteB.localeCompare(websiteA);
        });
      },
  },
  data: () => {
    return {
      id: 0,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        Name: "",
        Address: "",
        country: {},
        phone: "",
        website: "",
        contactPersonName: "",
        contactPersonRole: "",
        contactPersonEmail: "",
        contactPersonPhone: "",
      },
      Name: "",
      Address: "",
      phone: "",
      website: "",
      contactPersonName: "",
      contactPersonRole: "",
      contactPersonEmail: "",
      contactPersonPhone: "",
      Search: "",
      ISSNRules: [(v) => !!v || "Name is required"],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      InstitutionalRules: [(v) => !!v || "Institution Name is required"],
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC: true },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Institutions.vue